import TestCategories from "./TestCategories";
import PropTypes from "prop-types";
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

const cardData = [
  {
    title: "Screening Test",
    description:
      "Gain a quick overview of your foundational skills and competencies to determine initial job fit. This test focuses on core qualifications and eligibility criteria..",
    link: "/screening",
  },
  {
    title: "Behavioural Test",
    description:
      "Evaluate how you respond to workplace situations, manage challenges, and collaborate with others. Understand your behavior in action.",
    link: "/behavioural",
  },
  {
    title: "Personality Test",
    description:
      "Explore your personality traits and behavioral tendencies to see how they align with team dynamics and company values. It's a deep dive into who you are.",
    link: "/personality",
  },
  {
    title: "Overall Evaluation",
    description:"A complete evaluation thoroughly covering skills, personality, and behavior. This integrated approach provides a comprehensive 360-degree view of your potential.",
    link: "/overall_test",
  },
  {
    title: "Personality and Behavioural Test",
    description:
      "Gain a comprehensive understanding of your personality traits and behaviors, helping you tackle real-world challenges effectively.",
    link: "/combined",
  },
];

const FrameComponent8 = ({ className = "" }) => {
  return (
    <div className={cn("absolute top-[678px] left-[calc(50%-680px)] w-[1360px] flex flex-col items-center gap-[126px] max-w-full text-center text-3xl", className)}>
      <Container>
        <Stack spacing="lg" align="center" className="w-[1084px] max-w-full">
          <Heading level="h2" className="self-stretch text-4xl md:text-5xl font-bold text-foreground">
            Explore Our Comprehensive Assessment Tests
          </Heading>
          <Text variant="muted" size="lg" className="w-[949px] max-w-full text-xl font-semibold">
            Our AI connects you with the right candidates for a variety of tests designed to evaluate skills, personality, and behavior—helping you identify talent with precision and confidence!
          </Text>
        </Stack>
      </Container>
      <TestCategories
        cardData={cardData}
        testCategoriesHeight="300px"
        testCategoriesMinWidth="300px"
        testActionsBorder="1px solid #ccc"
        testActionsBackgroundColor="#fff"
      />
    </div>
  );
};

FrameComponent8.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent8;
